// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRelatedVideos_root__be_EN","header":"ArticleRelatedVideos_header__A6ntv","wrapper":"ArticleRelatedVideos_wrapper__aRCWi","video":"ArticleRelatedVideos_video__Yd6aS"};